export default {"src":"/_next/static/image/public/assets/user.4a9bfe057b4bb6c9216cf70b56d0d881.svg","height":41,"width":41};